import { orgGuidBillingCount, orgGuidBillingData } from '../../../../../api/orgGuidAPI';
import errorHandle from '../../../../../utils/errorHandle';

export const fetchGuideBillingCount = async (setTotalCount, selectedStatus, selectedApproval, setLoading) => {
    try {
        const response = await orgGuidBillingCount(selectedStatus, selectedApproval);
        setTotalCount(response.data.billsCount);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchGuideBillingsData = async (
    selectedStatus,
    selectedApproval,
    limit,
    offset,
    setBillingData,
    setLoading
) => {
    setLoading(true);
    try {
        const response = await orgGuidBillingData(selectedStatus, selectedApproval, limit, offset);
        setBillingData(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
